import styled from '../../../config/theme'

const Charts = styled.div`
  display: flex;
  padding: 10px;

  @media screen and (max-width: ${props => props.theme.mediaQueries.layout}) {
    flex-direction: column;
  }

  > * {
    flex: 1;
    margin: 10px;
  }
`

const Numbers = styled.div`
  display: flex;
  padding: 20px;
  padding-top: 0;

  @media screen and (max-width: ${props => props.theme.mediaQueries.layout}) {
    flex-direction: column;
  }

  > * {
    flex: 1;
  }
`

export {
  Charts,
  Numbers,
}
